import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { fmtPct } from "../lib/format";

/**
 * PillDelta — a small rounded pill that shows a signed % change with a tinted
 * background. Green for positive, red for negative, muted grey for zero.
 * The pill uses functional status colors, not brand accents.
 */
export const PillDelta = ({ value, showIcon = true, testId, tone = "auto", label }) => {
  const v = Number(value);
  const isZero = !Number.isFinite(v) || Math.abs(v) < 0.05;
  const positive = v > 0;
  const style = tone === "muted" || isZero
    ? { color: "#6B6E7E", bg: "#EEF0F5" }
    : positive
      ? { color: "#12B76A", bg: "#ECFDF3" }
      : { color: "#F04438", bg: "#FEF3F2" };

  const Icon = isZero ? Minus : positive ? TrendingUp : TrendingDown;

  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold tabular-nums whitespace-nowrap"
      style={{ color: style.color, background: style.bg }}
    >
      {showIcon && <Icon size={11} strokeWidth={2.4} />}
      {Number.isFinite(v) ? fmtPct(v) : "—"}
      {label && <span className="text-[10px] font-medium opacity-80 ml-0.5">{label}</span>}
    </span>
  );
};

export default PillDelta;
